import { initNavigationData } from '@/utils/store/filterGroups/filterGroupsNavigation';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { GroupManagementState } from './types/index';

export { namespace } from './types/index';

export const state: GroupManagementState = {
  groupsComponentsState: {
    loading: {
      groups: false,
      total: false
    },
    error: {
      groups: false,
      total: false
    },
    fetched: {
      groups: true,
      total: true
    }
  },
  groups: {
    filterGroups: {
      group: [
      ]
    }
  },
  navigation: initNavigationData,
  total: 0,
  errorMessage: '',
  userSelection: {
    groups: [],
    actions: {}
  }
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
